import { ScrollReveal } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Two Column Text",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/two-column-text", (props) => {
  return (
    <ScrollReveal>
      <div className={cn("w-grid mx-auto my-10")}>
        <div
          className={cn(
            "w-full",
            !env.admin &&
              "grid-auto [&>*]:col-span-12 md:[&>*]:col-span-5 md:[&>*:nth-child(2n)]:col-span-4 md:[&>*:nth-child(2n)]:col-start-8 gap-7 md:gap-0",
          )}
        >
          <InnerBlocks
            adminClassName="grid grid-cols-1 md:grid-cols-2 items-start justify-start gap-7"
            allowedBlocks={["content/two-column-text-item"]}
            template={[
              ["content/two-column-text-item", {}],
              ["content/two-column-text-item", {}],
            ]}
            templateLock="all"
            orientation="horizontal"
          />
        </div>
      </div>
    </ScrollReveal>
  )
})
